import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import TimelineItem from '../../TimeLine/TimelineItem';
import { selectSelectedClaim } from '../../../redux/store/userData/claims';
import { openModal } from '../../../redux/store/ui/common';
import styles from './ClaimTimeline.styles';

const ClaimTimeline: React.FC = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const selectedClaim = useSelector(selectSelectedClaim) as any;

  const onClickAdd = () => dispatch(openModal('ClaimTimelineAddModal'));

  const notes = selectedClaim?.notes || [];

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginRight: 24,
        }}
      >
        <img
          data-testid="ClaimTimeline-addBtn"
          style={{ width: 18, height: 18, cursor: 'pointer' }}
          src="/images/drawer/add.svg"
          alt="add"
          onClick={onClickAdd}
        />
      </div>
      <div data-testid="ClaimTimeline-timelineData" className="claim-timeline">
        {[...notes].reverse().map((noteEvent: any, i: number) => (
          <TimelineItem
            key={`claimNotes-${i}`}
            vehicleEvent={{
              type: noteEvent?.file ? 'documentAdded' : 'noteAdded',
              author: noteEvent?.operator,
              addedAt: noteEvent?.timestamp,
              ...noteEvent,
            }}
          />
        ))}
        {notes.length === 0 && (
          <div className="empty-wrapper">
            <img
              className="empty"
              src="/images/table/empty.svg"
              width="50"
              height="50"
            />
            {intl.formatMessage({ id: 'fleetadmin.users.info.empty' })}
          </div>
        )}
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default ClaimTimeline;
